import React from 'react';

const TopManagementRoute = ({ children }) => {
  return children;
};

export default TopManagementRoute;
